
import { feedbackQueryService } from "./feedbackQueryService";
import { feedbackMutationService } from "./feedbackMutationService";

// Export individual services
export { feedbackQueryService } from "./feedbackQueryService";
export { feedbackMutationService } from "./feedbackMutationService";

/**
 * Consolidated feedback service that combines query and mutation services
 */
export const feedbackService = {
  // Query methods
  getFeedbacksByRecipeId: feedbackQueryService.getFeedbacksByRecipeId,
  
  // Mutation methods
  saveFeedback: feedbackMutationService.saveFeedback,
};

// Export default for consistency with other service modules
export default feedbackService;
